"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactHelmet = require("react-helmet");
var _getUrlParams = _interopRequireDefault(require("../../packages/getUrlParams"));
var _jsxRuntime = require("react/jsx-runtime");
const Ensighten = function (_ref) {
  let {
    shareUrl = "",
    ensightenUrl = "",
    legacy = false
  } = _ref;
  const disableAnalytics = (0, _getUrlParams.default)("disableAnalytics");
  const bootstrapUrl = (0, _getUrlParams.default)("ensightenUrl") || ensightenUrl;
  const ANALYTICS_URLS = legacy ? [`${shareUrl}/s_code.js`, `${shareUrl}/cod.js`, bootstrapUrl] : [bootstrapUrl];
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactHelmet.Helmet, {
    "data-testid": "Ensighten",
    children: !disableAnalytics && ANALYTICS_URLS.map(function (url) {
      return /*#__PURE__*/(0, _jsxRuntime.jsx)("script", {
        src: url,
        "data-testid": "Ensighten"
      }, url);
    })
  });
};
var _default = exports.default = Ensighten;